export interface Article {
  id: string;
  slug: string;
  title: string;
  excerpt: string;
  content: string;
  category: string;
  categorySlug: string;
  coverImage: string;
  author: string;
  publishDate: string;
  readTime: number;
  viewCount: number;
  commentCount: number;
  tags: string[];
  isHot: boolean;
  isFeatured: boolean;
}

export interface Category {
  name: string;
  slug: string;
  icon: string;
  description: string;
  articleCount: number;
}

export const categories: Category[] = [
  { name: '明星爆料', slug: 'star-scandal', icon: 'ri-star-line', description: '明星艺人最新黑料内幕，深度揭秘娱乐圈不为人知的真相', articleCount: 128 },
  { name: '网红内幕', slug: 'influencer-expose', icon: 'ri-live-line', description: '网红博主背后的真实面目，揭露虚假人设与行业内幕', articleCount: 96 },
  { name: '综艺真相', slug: 'variety-truth', icon: 'ri-tv-line', description: '综艺节目幕后操作，揭秘真人秀背后的剧本与潜规则', articleCount: 74 },
  { name: '影视黑幕', slug: 'film-industry', icon: 'ri-film-line', description: '影视圈暗箱操作，导演、制片人、演员之间的利益纠葛', articleCount: 85 },
  { name: '音乐圈乱象', slug: 'music-chaos', icon: 'ri-music-line', description: '音乐行业抄袭、假唱、数据造假等乱象深度调查', articleCount: 53 },
  { name: '时尚圈潜规', slug: 'fashion-rules', icon: 'ri-shirt-line', description: '时尚圈品牌代言、红毯造型背后的利益交易与潜规则', articleCount: 41 },
];

export const articles: Article[] = [
  {
    id: '1',
    slug: 'top-star-tax-evasion-exposed',
    title: '某顶流男星涉嫌偷税漏税被调查，金额或达数亿元',
    excerpt: '据知情人士透露，该男星近年来通过各种手段规避税收，涉及金额巨大。税务部门已介入调查，或将面临巨额罚款。',
    content: `<p>近日，据圈内知情人士向本平台独家爆料，某顶流男星因涉嫌偷税漏税正在接受税务部门调查。据悉，该男星近年来通过设立空壳公司、阴阳合同等手段，涉嫌偷逃税款金额或高达数亿元人民币。</p>
    <p>该爆料者透露，税务部门在半年前就已注意到该艺人的税务异常，经过数月的秘密调查，目前已掌握大量证据。该艺人近三年来的代言收入、片酬收入与实际申报金额存在巨大差异。</p>
    <h2>阴阳合同内幕</h2>
    <p>据业内人士透露，阴阳合同在娱乐圈并非个例。所谓"阳合同"是向税务部门申报的低价合同，而"阴合同"才是实际履行的真实价格合同。这种做法在影视行业尤为普遍。</p>
    <p>该男星在去年参演的一部大制作电影中，对外公布的片酬为3000万元，但实际收到的片酬高达1.2亿元。差额部分通过多家关联公司以"咨询费""策划费"等名义进行转账，以此规避高额个人所得税。</p>
    <h2>涉及的品牌代言</h2>
    <p>该男星目前代言的品牌包括多个国际奢侈品牌和国内知名品牌，年代言费用估算在8000万至1亿元之间。如果税务问题坐实，这些品牌方可能会面临解约风险。</p>
    <p>目前已有两个品牌方内部紧急召开了会议，讨论应对方案。业内人士分析，一旦官方通报发出，各品牌方大概率会在24小时内发布解约声明。</p>
    <h2>或将面临的处罚</h2>
    <p>根据我国相关法律法规，偷税漏税金额巨大的，除了补缴税款外，还将面临数倍罚款。如果金额特别巨大且情节严重，甚至可能面临刑事责任。</p>
    <p>此前某女星因类似问题被追缴税款、滞纳金及罚款共计超过8亿元。业内人士预测，该男星的涉案金额可能不亚于此。</p>
    <p>截至发稿时，该男星工作室尚未对此事做出公开回应。本平台将持续关注事件进展。</p>`,
    category: '明星爆料',
    categorySlug: 'star-scandal',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20dramatic%20artistic%20composition%20with%20dark%20red%20and%20black%20tones%2C%20silhouette%20of%20a%20person%20behind%20frosted%20glass%2C%20scattered%20documents%20and%20money%20symbols%20floating%20in%20the%20air%2C%20mysterious%20and%20investigative%20mood%2C%20cinematic%20lighting%20with%20warm%20amber%20highlights%20on%20dark%20background%2C%20editorial%20photography%20style%2C%20high%20contrast%2C%20dramatic%20shadows&width=1200&height=675&seq=article-cover-01&orientation=landscape',
    author: '黑料调查组',
    publishDate: '2026-08-07',
    readTime: 8,
    viewCount: 125800,
    commentCount: 3421,
    tags: ['偷税漏税', '顶流男星', '阴阳合同', '税务调查', '娱乐圈'],
    isHot: true,
    isFeatured: true,
  },
  {
    id: '2',
    slug: 'popular-actress-divorce-inside-story',
    title: '当红女星离婚内幕：第三者竟是圈内知名导演',
    excerpt: '表面和平分手的背后，隐藏着一段不为人知的婚外情。该女星与知名导演的暧昧关系已持续两年之久。',
    content: `<p>昨日宣布离婚的当红女星，其离婚原因并非此前媒体报道的"性格不合"。据本平台独家获取的消息，真正导致婚姻破裂的原因是该女星与一位圈内知名导演长达两年的婚外情。</p>
    <p>消息人士称，该女星与其丈夫早在一年前就已分居，但为了维护各自的商业利益和公众形象，一直对外维持着表面和谐的婚姻关系。</p>
    <h2>婚外情始末</h2>
    <p>据悉，该女星与这位导演相识于三年前的一部电影合作。当时该导演已婚，女星也已婚。两人在拍摄期间因工作关系频繁接触，逐渐产生了超越工作关系的感情。</p>
    <p>剧组工作人员透露，当时在片场就经常看到两人单独在导演的房车内讨论剧本，时间往往长达数小时。起初大家并未多想，但后来发现两人的关系明显超出了正常工作范畴。</p>
    <h2>商业利益的纠葛</h2>
    <p>该女星与丈夫共同持有多家公司股份，涉及影视制作、艺人经纪、餐饮等多个领域。如果直接公开离婚原因，可能会对这些公司的估值和运营造成重大影响。</p>
    <p>据了解，两人已就财产分割达成协议。女星将保留大部分影视相关资产，而其丈夫则获得餐饮板块的全部股权以及数亿元现金补偿。</p>
    <p>目前，该女星和那位导演均未对此事做出回应。但其工作室发布声明称"请尊重艺人隐私，勿信谣传谣"。</p>`,
    category: '明星爆料',
    categorySlug: 'star-scandal',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20moody%20artistic%20image%20of%20a%20shattered%20wedding%20ring%20on%20a%20dark%20velvet%20surface%2C%20soft%20dramatic%20lighting%20from%20the%20side%2C%20deep%20crimson%20and%20black%20color%20palette%2C%20mysterious%20atmosphere%2C%20fragments%20of%20glass%20scattered%20around%2C%20conceptual%20editorial%20photography%2C%20emotional%20and%20powerful%20composition&width=1200&height=675&seq=article-cover-02&orientation=landscape',
    author: '深度八卦',
    publishDate: '2026-08-06',
    readTime: 10,
    viewCount: 98700,
    commentCount: 5621,
    tags: ['女星离婚', '婚外情', '知名导演', '娱乐圈婚姻', '财产分割'],
    isHot: true,
    isFeatured: true,
  },
  {
    id: '3',
    slug: 'top-influencer-fake-persona-exposed',
    title: '千万粉丝网红人设崩塌：名校学历造假、租豪宅摆拍',
    excerpt: '这位以"高学历精英人设"走红的网红博主，实际只有高中学历。其展示的豪宅、豪车均系租赁或借用。',
    content: `<p>近日，一位拥有超过1500万粉丝的知名网红被曝出其精心打造的人设全部造假。该网红长期以来以"海归精英""名校MBA"的人设吸引粉丝，但事实远非如此。</p>
    <h2>学历造假</h2>
    <p>该网红在多个视频中声称自己毕业于美国某常春藤盟校，并获得了MBA学位。然而经查证，该校学生数据库中并无此人的任何记录。实际情况是，该网红仅有高中学历，所谓的"留学经历"完全子虚乌有。</p>
    <p>更令人震惊的是，该网红曾在直播中详细描述自己的"留学生活"，包括校园环境、课堂体验、教授互动等细节，但这些描述与该校实际情况完全不符，显然是参照网络信息编造而成。</p>
    <h2>生活造假</h2>
    <p>该网红日常展示的上海某高端小区豪宅，实际为月租形式，且租金由MCN公司承担。视频中出现的多辆豪车均为租车公司借调，拍摄结束后即归还。</p>
    <p>其展示的"私人飞机出行""游艇派对"等场景，实际均为参加商业活动时蹭拍，并非其个人消费。</p>
    <h2>MCN公司的操作模式</h2>
    <p>业内人士透露，这其实是MCN公司打造网红人设的常见手法。通过包装虚假身份、租赁奢侈品来制造"成功人士"的假象，以此吸引粉丝关注和品牌合作。</p>
    <p>目前该网红的所有社交账号评论区已被质疑声淹没，多个合作品牌已紧急暂停与其的合作关系。</p>`,
    category: '网红内幕',
    categorySlug: 'influencer-expose',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20conceptual%20image%20of%20a%20cracked%20smartphone%20screen%20with%20social%20media%20icons%2C%20dark%20background%20with%20neon%20pink%20and%20red%20accents%2C%20glitch%20effect%2C%20dystopian%20digital%20atmosphere%2C%20fake%20persona%20concept%2C%20dramatic%20lighting%2C%20high%20contrast%20editorial%20style&width=1200&height=675&seq=article-cover-03&orientation=landscape',
    author: '网红观察室',
    publishDate: '2026-08-05',
    readTime: 7,
    viewCount: 156300,
    commentCount: 8920,
    tags: ['网红塌房', '人设造假', '学历造假', 'MCN内幕', '粉丝经济'],
    isHot: true,
    isFeatured: false,
  },
  {
    id: '4',
    slug: 'variety-show-scripted-secrets',
    title: '综艺节目剧本曝光：冠军人选早在录制前已内定',
    excerpt: '某热门选秀综艺内部人员爆料，节目中的淘汰、晋级环节均按剧本进行，最终冠军早在一个月前就已确定。',
    content: `<p>某热门选秀综艺节目的一名离职工作人员向本平台爆料，该节目的所有比赛环节、淘汰结果、甚至选手之间的矛盾冲突都是按照事先撰写好的剧本执行的。</p>
    <h2>剧本内幕</h2>
    <p>据爆料人透露，该节目的剧本主要由总导演和三名核心编剧共同完成。在正式录制前一个月，节目组就已经确定了最终的冠亚季军人选以及每一期淘汰的选手。</p>
    <p>选手们在舞台上的表现虽然有一定的真实成分，但评委的点评、选手之间的互动、以及"意外冲突"等戏剧性场景，全部都是经过精心设计的结果。</p>
    <h2>选手的不公平待遇</h2>
    <p>一些实力出众但"不配合剧本"的选手往往会在早期被淘汰。反之，一些实力平庸但"听话配合"的选手则会被一路保送至后期。</p>
    <p>爆料人举例说，第三季的一位实力派选手因为在录制现场多次质疑比赛规则的公平性，结果在下一轮就被安排"意外出局"，而其淘汰的理由在剪辑后显得十分牵强。</p>
    <p>目前该节目组尚未对此爆料做出回应。</p>`,
    category: '综艺真相',
    categorySlug: 'variety-truth',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20theatrical%20stage%20with%20spotlights%20and%20empty%20chairs%2C%20dark%20backstage%20atmosphere%2C%20scripts%20and%20papers%20scattered%20on%20the%20floor%2C%20dramatic%20red%20curtain%20partially%20drawn%2C%20mysterious%20backstage%20vibe%2C%20warm%20spotlight%20contrasting%20with%20dark%20shadows%2C%20cinematic%20composition&width=1200&height=675&seq=article-cover-04&orientation=landscape',
    author: '综艺揭秘',
    publishDate: '2026-08-04',
    readTime: 6,
    viewCount: 89300,
    commentCount: 4521,
    tags: ['综艺内幕', '选秀黑幕', '剧本操作', '真人秀', '娱乐产业'],
    isHot: false,
    isFeatured: false,
  },
  {
    id: '5',
    slug: 'film-investment-money-laundering',
    title: '电影投资背后：多部大制作涉嫌洗钱，投资人血本无归',
    excerpt: '影视投资已成某些人的洗钱工具。表面光鲜的大制作电影，背后暗藏资金运作的黑幕。',
    content: `<p>近年来，中国电影市场蓬勃发展，但在这繁荣背后，隐藏着一条令人震惊的灰色产业链。多位业内人士向本平台证实，影视投资已成为某些人洗钱的重要途径。</p>
    <h2>电影洗钱的常见手法</h2>
    <p>业内人士透露，电影洗钱最常见的方式是虚增制作成本。一部实际制作成本仅5000万的电影，对外宣称投资3亿，其中2.5亿的差额就是需要洗白的资金。</p>
    <p>这些资金通过虚假的"道具采购""场地租赁""特效制作"等名目流入关联公司账户，经过多层转账后最终变成合法收入。</p>
    <h2>受害的普通投资者</h2>
    <p>为了吸引社会资金参与，这些项目通常会以"保底收益""明星阵容""大IP"等噱头招揽普通投资人。然而，由于大部分投资款已被提前转移，即使电影获得不错的票房，普通投资人也很难收回成本。</p>
    <p>据统计，近三年来已有超过200部国产电影的实际投资人出现亏损，其中不乏票房过亿的"成功"影片。</p>`,
    category: '影视黑幕',
    categorySlug: 'film-industry',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20dark%20cinematic%20image%20of%20a%20film%20clapperboard%20with%20money%20bills%20scattered%20around%20it%2C%20shadowy%20figures%20in%20the%20background%2C%20red%20and%20black%20color%20scheme%2C%20dramatic%20noir%20lighting%2C%20mysterious%20and%20suspenseful%20atmosphere%2C%20conceptual%20photography%20about%20corruption%20in%20film%20industry&width=1200&height=675&seq=article-cover-05&orientation=landscape',
    author: '影视调查',
    publishDate: '2026-08-03',
    readTime: 9,
    viewCount: 67300,
    commentCount: 3241,
    tags: ['电影投资', '洗钱', '影视黑幕', '投资人', '制作成本'],
    isHot: false,
    isFeatured: false,
  },
  {
    id: '6',
    slug: 'music-plagiarism-scandal-2026',
    title: '2026年最大音乐抄袭丑闻：五首热歌涉嫌抄袭海外作品',
    excerpt: '音乐圈抄袭风波再起。多首霸榜热歌被指出与海外冷门歌曲高度相似，抄袭手段越来越隐蔽。',
    content: `<p>近日，音乐圈再次掀起抄袭风波。有网友发现，目前霸占各大音乐平台排行榜的五首热门歌曲，与多首海外相对冷门的歌曲在旋律、和弦进行上存在高度相似。</p>
    <h2>抄袭手法剖析</h2>
    <p>音乐制作人分析指出，这些歌曲的抄袭手法十分隐蔽："他们不是简单地复制整段旋律，而是将原曲的精华部分打散重组，再加入一些原创段落来混淆视听。这种做法在法律上很难界定。"</p>
    <h2>行业潜规则</h2>
    <p>多位音乐人向本平台透露，这种现象在业内已是公开的秘密。一些制作公司专门收集海外冷门歌曲作为"素材库"，提供给旗下音乐人"借鉴"。由于被借鉴的歌曲在海外知名度不高，国内听众很难发现。</p>
    <p>目前，被指抄袭的歌手和制作团队已发布声明，称所有作品均为原创，将保留追究法律责任的权利。</p>`,
    category: '音乐圈乱象',
    categorySlug: 'music-chaos',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20dark%20studio%20scene%20with%20headphones%20and%20sheet%20music%2C%20torn%20music%20notes%20floating%20in%20the%20air%2C%20dramatic%20red%20and%20black%20lighting%2C%20conceptual%20image%20about%20music%20plagiarism%2C%20mysterious%20atmosphere%2C%20editorial%20photography%20style%2C%20high%20contrast&width=1200&height=675&seq=article-cover-06&orientation=landscape',
    author: '音乐调查局',
    publishDate: '2026-08-02',
    readTime: 7,
    viewCount: 112400,
    commentCount: 6780,
    tags: ['音乐抄袭', '热歌', '原创争议', '音乐产业', '版权问题'],
    isHot: true,
    isFeatured: false,
  },
  {
    id: '7',
    slug: 'luxury-brand-endorsement-secrets',
    title: '奢侈品代言潜规则：明星代言费一半流入经纪人口袋',
    excerpt: '揭秘时尚圈代言背后的利益链。当红明星的代言合同，签约金额与实际到手差距悬殊。',
    content: `<p>在光鲜亮丽的时尚圈代言背后，隐藏着错综复杂的利益分配链条。本平台独家获取的多份代言合同显示，明星实际到手的代言费往往只有对外公布数字的三到五成。</p>
    <h2>利益分配链条</h2>
    <p>据一位资深艺人经纪人透露，一笔标注为2000万的代言合同，实际分配大致如下：经纪人抽成30%-40%，公司抽成20%-30%，缴纳税费后，艺人实际到手可能只有500万-800万。</p>
    <p>此外，一些经纪人还会通过虚报代言费的方式从中渔利。例如与品牌方谈定1500万，但向艺人汇报时只说1000万，差额部分就被中间环节瓜分。</p>
    <h2>品牌的算计</h2>
    <p>品牌方也并非完全被动。他们会通过复杂的合同条款来最大化自身利益，包括独家排他条款、竞品限制条款、形象维护条款等。一旦艺人出现负面新闻，品牌方不仅可以零成本解约，甚至可以向艺人索赔。</p>`,
    category: '时尚圈潜规',
    categorySlug: 'fashion-rules',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20luxurious%20dark%20scene%20with%20a%20designer%20handbag%20and%20shattered%20mirror%2C%20red%20lipstick%20smear%2C%20dramatic%20lighting%2C%20conceptual%20fashion%20industry%20corruption%20theme%2C%20dark%20elegance%2C%20editorial%20photography%2C%20mysterious%20glamour%20with%20dark%20undertones&width=1200&height=675&seq=article-cover-07&orientation=landscape',
    author: '时尚调查组',
    publishDate: '2026-08-01',
    readTime: 8,
    viewCount: 56300,
    commentCount: 2130,
    tags: ['奢侈品代言', '明星收入', '经纪人抽成', '时尚圈', '代言合同'],
    isHot: false,
    isFeatured: false,
  },
  {
    id: '8',
    slug: 'wanghong-live-streaming-fraud',
    title: '网红带货翻车：百万粉丝主播售卖假货，退货率超80%',
    excerpt: '直播带货虚假繁荣背后，某知名带货主播直播间商品被检测出大量假货，退货率惊人。',
    content: `<p>直播带货行业再曝丑闻。一位拥有超过500万粉丝的头部带货主播被消费者集体投诉，其直播间售卖的多个品牌商品经鉴定为假货。</p>
    <h2>假货泛滥</h2>
    <p>据投诉者提供的检测报告，该主播售卖的某国际品牌护肤品、名牌包袋等多款商品均被鉴定为假冒产品。这些假货的仿真度极高，普通消费者根本无法辨别。</p>
    <p>更令人气愤的是，该主播在直播间反复强调"假一赔十""正品保证"，并展示所谓的"品牌授权书"来获取消费者信任。事后调查发现，这些授权书均为伪造。</p>
    <h2>惊人的退货率</h2>
    <p>据平台内部数据显示，该主播直播间的实际退货率高达82%，远超行业平均水平。但由于其庞大的粉丝基数，即便退货率高，仍有可观的利润空间。</p>
    <p>目前，涉事平台已冻结该主播的账户，并表示将配合相关部门进行调查。多个消费者维权群已组建，涉及金额超过500万元。</p>`,
    category: '网红内幕',
    categorySlug: 'influencer-expose',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20dark%20ecommerce%20concept%20image%2C%20shopping%20cart%20with%20broken%20products%2C%20fake%20luxury%20items%2C%20dramatic%20red%20warning%20lights%2C%20livestreaming%20setup%20in%20shadows%2C%20conceptual%20photography%20about%20online%20shopping%20fraud%2C%20mysterious%20atmosphere&width=1200&height=675&seq=article-cover-08&orientation=landscape',
    author: '消费调查',
    publishDate: '2026-07-31',
    readTime: 6,
    viewCount: 198400,
    commentCount: 12450,
    tags: ['直播带货', '假货', '网红翻车', '消费者维权', '退货率'],
    isHot: true,
    isFeatured: true,
  },
  {
    id: '9',
    slug: 'talent-show-judge-bribery',
    title: '选秀评委受贿丑闻：某评委收取选手百万"通关费"',
    excerpt: '选秀节目评委受贿内幕曝光。某知名评委被指在节目中为付费选手开后门，保证其进入决赛。',
    content: `<p>选秀节目的公正性再次遭受质疑。本平台接到爆料称，某热门选秀节目的常驻评委在最新一季节目中，收取了多名选手的"通关费"，金额从50万到200万不等。</p>
    <h2>收费"套餐"</h2>
    <p>据爆料人透露，该评委甚至有一套明码标价的"套餐"：基础套餐50万，保证通过海选进入正赛；高级套餐100万，保证进入前20名；VIP套餐200万，保证进入总决赛。</p>
    <p>缴费选手在比赛中会受到该评委的特殊照顾，不仅在点评环节给予高度评价，还会在其他评委提出批评时帮忙"圆场"。反之，未缴费的实力选手则经常在关键环节被该评委刻意打压。</p>
    <h2>节目组的态度</h2>
    <p>更令人震惊的是，节目组对此并非不知情。爆料人表示，节目总导演对此默许甚至纵容，因为"交钱"的选手往往会在节目中制造更多话题和流量。</p>
    <p>目前该节目已暂停录制，相关方面表示将展开内部调查。</p>`,
    category: '综艺真相',
    categorySlug: 'variety-truth',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20dark%20judging%20panel%20scene%2C%20empty%20chairs%20with%20name%20cards%2C%20money%20envelopes%20on%20the%20table%2C%20dramatic%20spotlight%2C%20corruption%20concept%2C%20red%20and%20black%20color%20scheme%2C%20cinematic%20lighting%2C%20tense%20atmosphere&width=1200&height=675&seq=article-cover-09&orientation=landscape',
    author: '选秀观察',
    publishDate: '2026-07-30',
    readTime: 7,
    viewCount: 143200,
    commentCount: 8760,
    tags: ['选秀评委', '受贿', '通关费', '比赛公正', '综艺黑幕'],
    isHot: true,
    isFeatured: false,
  },
  {
    id: '10',
    slug: 'celebrity-secret-marriage-hidden-children',
    title: '多位明星被曝隐婚生子，娱乐圈地下婚姻何时休？',
    excerpt: '明星隐婚现象愈发普遍。据不完全统计，近三年已有超过30位艺人的婚姻状况与公开信息不符。',
    content: `<p>近日，又有三位知名艺人被曝出隐婚生子的消息，再次引发公众对娱乐圈"地下婚姻"现象的热议。</p>
    <h2>隐婚的经济账</h2>
    <p>业内人士分析，明星选择隐婚的主要原因有三：一是维护"单身人设"以保持粉丝特别是"女友粉""男友粉"的忠诚度；二是避免影响商业代言合同的履行；三是保护家人隐私。</p>
    <p>然而，第一位原因是最主要的。某流量男星的经纪人坦言："一旦公开结婚，商业价值至少缩水30%。特别是那些依靠粉丝打榜、应援维持热度的偶像型艺人，结婚等于事业自杀。"</p>
    <h2>隐婚产业链</h2>
    <p>随着隐婚需求的增加，甚至催生了一条"隐婚服务产业链"。从秘密登记的海外结婚中介，到保密生产的私立医院，再到低调奢华的全封闭小区，应有尽有。</p>
    <p>有知情人士透露，某些顶级流量明星每年在"隐婚安保"上的花费就高达数百万元。</p>`,
    category: '明星爆料',
    categorySlug: 'star-scandal',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20mysterious%20wedding%20concept%20image%2C%20wedding%20ring%20hidden%20in%20shadows%2C%20silhouette%20of%20a%20couple%20behind%20frosted%20glass%2C%20dark%20romantic%20atmosphere%2C%20red%20and%20black%20tones%2C%20secretive%20mood%2C%20editorial%20photography%20style&width=1200&height=675&seq=article-cover-10&orientation=landscape',
    author: '婚姻调查组',
    publishDate: '2026-07-29',
    readTime: 8,
    viewCount: 178500,
    commentCount: 9870,
    tags: ['隐婚', '明星婚姻', '地下恋情', '流量明星', '娱乐圈现状'],
    isHot: false,
    isFeatured: false,
  },
  {
    id: '11',
    slug: 'award-ceremony-behind-scenes',
    title: '颁奖典礼幕后：各大奖项早已内定，明星出席都是交易',
    excerpt: '一年一度的娱乐盛典背后，奖项分配、明星出席、座位安排都暗藏玄机。',
    content: `<p>每年各大颁奖典礼星光熠熠的背后，其实是一场精心设计的利益交换游戏。本平台通过多方渠道，还原了颁奖典礼的真实运作机制。</p>
    <h2>奖项的交易逻辑</h2>
    <p>据一位参与过多届颁奖典礼策划的业内人士透露，重要奖项的归属往往在典礼前一个月就已确定。确定标准并非作品质量或人气投票，而是基于复杂的利益交换。</p>
    <p>例如，某艺人愿意以低于市场价50%的出场费参加典礼，作为交换，主办方承诺给予其一个重要奖项。品牌赞助商也有推荐人选的权利，赞助金额越高，话语权越大。</p>
    <h2>座位安排的玄机</h2>
    <p>颁奖典礼的座位安排同样暗藏玄机。前排座位通常留给有利益关联的艺人，而非单纯按资历或热度排位。一个座位的位置，往往代表着该艺人与主办方、赞助商之间的关系亲疏。</p>`,
    category: '明星爆料',
    categorySlug: 'star-scandal',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20dark%20award%20ceremony%20scene%2C%20golden%20trophy%20with%20shadow%20hands%20reaching%20for%20it%2C%20dramatic%20red%20carpet%2C%20mysterious%20atmosphere%2C%20conceptual%20image%20about%20corruption%20in%20awards%2C%20cinematic%20lighting%2C%20high%20contrast&width=1200&height=675&seq=article-cover-11&orientation=landscape',
    author: '盛典揭秘',
    publishDate: '2026-07-28',
    readTime: 6,
    viewCount: 76500,
    commentCount: 3420,
    tags: ['颁奖典礼', '内定奖项', '娱乐盛典', '利益交换', '座位玄机'],
    isHot: false,
    isFeatured: false,
  },
  {
    id: '12',
    slug: 'short-video-platform-algorithm-manipulation',
    title: '短视频平台算法操控内幕：花钱就能买流量',
    excerpt: '某头部短视频平台内部员工爆料，平台存在付费流量池，商家和网红可以通过花钱购买推荐量。',
    content: `<p>短视频平台的"公平算法"可能只是一个谎言。本平台从某头部短视频平台离职员工处获悉，该平台存在一套隐秘的付费流量系统。</p>
    <h2>双轨流量池</h2>
    <p>据爆料人透露，该平台实际上运行着两套流量分配系统：一套是面向普通用户的自然流量池，另一套是面向付费客户的商业流量池。后者的推荐权重远高于前者。</p>
    <p>这意味着，一个内容质量普通的视频，只要创作者愿意付费，就能获得远超优质内容的曝光量。而真正优质但未付费的内容，反而可能被算法压制。</p>
    <h2>MCN的特权</h2>
    <p>与平台有深度合作的MCN机构享有特殊待遇。他们旗下的账号即使在违规边缘试探，也会被平台"睁一只眼闭一只眼"，而普通创作者稍有违规就会面临限流甚至封号。</p>`,
    category: '网红内幕',
    categorySlug: 'influencer-expose',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20dark%20digital%20concept%20image%2C%20smartphone%20screen%20showing%20algorithm%20patterns%2C%20shadow%20hands%20manipulating%20data%20flows%2C%20red%20and%20black%20neon%20accents%2C%20dystopian%20tech%20atmosphere%2C%20conceptual%20photography%2C%20dramatic%20lighting&width=1200&height=675&seq=article-cover-12&orientation=landscape',
    author: '科技调查',
    publishDate: '2026-07-27',
    readTime: 7,
    viewCount: 89700,
    commentCount: 4560,
    tags: ['短视频', '算法操控', '付费流量', 'MCN特权', '内容平台'],
    isHot: false,
    isFeatured: false,
  },
];

export const getArticleBySlug = (slug: string): Article | undefined => {
  return articles.find((a) => a.slug === slug);
};

export const getArticlesByCategory = (categorySlug: string): Article[] => {
  return articles.filter((a) => a.categorySlug === categorySlug);
};

export const getHotArticles = (): Article[] => {
  return articles.filter((a) => a.isHot);
};

export const getFeaturedArticles = (): Article[] => {
  return articles.filter((a) => a.isFeatured);
};

export const getLatestArticles = (count: number = 10): Article[] => {
  return [...articles].sort((a, b) => new Date(b.publishDate).getTime() - new Date(a.publishDate).getTime()).slice(0, count);
};

export const getRelatedArticles = (article: Article, count: number = 4): Article[] => {
  return articles
    .filter((a) => a.id !== article.id && a.categorySlug === article.categorySlug)
    .slice(0, count);
};

export const getCategoryBySlug = (slug: string): Category | undefined => {
  return categories.find((c) => c.slug === slug);
};